<div class="sign-in-container">

  <mat-card class="sign-in-card">

    <h1>Serendipity CRM</h1>

    <mat-card-content *ngIf="formGroup">

      <h2>Sign in</h2>

      <!-- Chrome ignores autocomplete="off" so go to chrome://settings/autofill and turn 'Auto-fill forms' off -->

      <dynamic-form autocomplete="off"
                    [className]="'nested-grid-container'"
                    [formGroup]="formGroup"
                    [model]="formModel">
      </dynamic-form>

      <mat-card-actions class="card-actions" fxLayoutAlign="flex-end">
        <button mat-raised-button color="accent" [disabled]="!isValid()" (click)="onSubmit()"> {{ signInButton }} </button>
      </mat-card-actions>

    </mat-card-content>

  </mat-card>

</div>

<!--

<mat-card-header>
  <mat-card-title>
    General Information
  </mat-card-title>
</mat-card-header>

-->
